import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChildren, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { log } from 'console';
import * as moment from 'moment';
import { AuthService } from 'src/app/core/services/auth.service';
import { chatMessage } from 'src/app/document/components/processed/processed.component';
import { DocumentAIService } from 'src/app/shared/services/documentAI.service';
import { SignalRService } from 'src/app/shared/services/SignalR.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'ai-agent',
    templateUrl: './ai-agent.component.html',
    styleUrl: './ai-agent.component.scss'
})
export class AiAgentComponent implements OnInit, AfterViewInit {
     get apiUrl(): string {
            return `${environment.API_Document_Url}`
        }
    @ViewChildren('fadeChatElements') fadeChatElements!: QueryList<ElementRef>;
    private hubConnection: signalR.HubConnection;
    @Input() isUnderProcessed: boolean = false; // Accept flag from parent
    @Input('agent') agent: string;
    @Input() taxona: boolean = false;
    @Output() updateCaseEventMessages: EventEmitter<any> = new EventEmitter<any>();
    @Output() hasRecordsChange: EventEmitter<boolean> = new EventEmitter<boolean>();
     @ViewChild('scrollbar') scrollbarRef: ElementRef | undefined
    processedMessages: Set<string> = new Set();
    containerHeight: number;
    AiAgentMessages: any[] = [];
    CaseTypeAssistants: any[] = [];
    assistantId: string;
    caseRecordId: any;
    caseAssistantId: string;
    caseTypeId: string;
    questionText: string = '';
    statusFilterByGuid:any;
    private idpSessionInterval: any;
    timerMessage: string = 'Thinking'
    sequence: number = 0;
    disableChat = false;
    queryString: string;
    assistantName = '';
    caseTypeAssistantId:string;
    isJoined: boolean = false;
    createCaseMessages: any[] = [];
    updateCaseMessages: any[] = [];
    statusUpdateMessages: any[] = [];
    updateJDataMessages: any[] = [];
    createJDataMessages: any[] = [];
    deleteJDataMessages: any[] = [];
    createFileMessages: any[] = [];
    updateFileMessages: any[] = [];
    otherMessages: any[] = [];
    lockMessages: any[] = [];
    unlockMessages: any[] = [];
    currentGroup: string = '';
    constructor(private service: DocumentAIService, private route: ActivatedRoute, public authService: AuthService, private signalRService: SignalRService, private http: HttpClient) {

    }

  ngAfterViewInit() {
}

    ngOnInit(): void {
        this.getBGClass();
        this.service.loadCaseDataFromSession();
        this.service.caseDataSubject.subscribe(data => {
            this.assistantId = data.caseAssistantId || this.assistantId;
            this.caseTypeAssistantId = data.caseAssistantId || this.caseTypeAssistantId;
            this.caseRecordId = data.caseRecordId;
      this.caseTypeId = data.caseTypeId;
    });
        if (this.isUnderProcessed === true) {
            // Clear any existing interval to prevent multiple intervals
            if (this.idpSessionInterval) {
                clearInterval(this.idpSessionInterval);
            }
            this.IdpSessionDetailses();
            this.idpSessionInterval = setInterval(() => {
                this.IdpSessionDetailses();
            }, 5000);
        } else {
            this.showChatHide();
        }
        this.chatScrollBottom();
        this.setContainerHeight();
    }

     chatScrollBottom() {
        setTimeout(() => {
            this.scrollbarRef?.nativeElement.scrollTo({
                top: this.scrollbarRef.nativeElement.scrollHeight,
                behavior: 'smooth',
            })
        }, 3000)
    }

    ngOnDestroy(): void {
            if (this.hubConnection) {
             this.hubConnection.stop();
           }

           if (this.idpSessionInterval) {
            clearInterval(this.idpSessionInterval);
           }
  }

    IdpSessionDetailses() {
        
        this.queryString = `?messagesFromFilter=${this.taxona ? 'Taxona' : 'Sortis'}&SkipCount=0&MaxResultCount=20&Sorting=messageOn desc`
        this.service.getIdpSessionDetailses(this.queryString).subscribe((data: any) => {
            const items = (data.result.items || []).map((item: any) => ({
                answerText: item.idpSessionDetails?.content || '-',
               messageOn: item.idpSessionDetails?.messageOn.endsWith('Z') ? item.idpSessionDetails?.messageOn : (item.idpSessionDetails?.messageOn + 'Z')
            }));
            this.AiAgentMessages = items
                .sort((a: any, b: any) => {
                    if (!a.messageOn) return -1;
                    if (!b.messageOn) return 1;
                    return new Date(a.messageOn).getTime() - new Date(b.messageOn).getTime();
                });
            this.hasRecordsChange.emit(this.AiAgentMessages.length > 0);
        });
    }
     GetDocumentChatByCaseId() {
      this.service.GetByNameCaseAssistantMessages(this.caseRecordId , this.assistantName , this.caseAssistantId).subscribe(
            (data: any) => {
                 this.AiAgentMessages = [];
                if (data?.result) {
                    this.AiAgentMessages = data.result.map((item: any) => ({
                        questionText: item.messageFrom || '-',
                        answerText: item.message || '-',
                        messageOn: item.messageOn?.endsWith('Z') ? item.messageOn : (item.messageOn + 'Z'),
                    }));
                        this.AiAgentMessages.sort((a, b) => {
                                if (!a.messageOn) return -1;
                                if (!b.messageOn) return 1;
                                return new Date(a.messageOn).getTime() - new Date(b.messageOn).getTime();
                            });
                } else {
                    console.error('Unexpected data format:', data);
                }
                this.hasRecordsChange.emit(this.AiAgentMessages.length > 0);
            },
            (error) => {
                console.error('Error fetching chat data:', error);
                this.hasRecordsChange.emit(false);
            }
        );
    }
    setContainerHeight() {
        this.containerHeight = window.innerHeight - 200
        if(this.isUnderProcessed ===false){
            this.containerHeight = +578
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.setContainerHeight()
    }
    // getObjectByGuid(list: any[], guid: string): any | null {
    //     return list.find((item:any) => item.caseTypeAssistantID === guid) || null;
    // }
    showChatHide() {
        this.service.getActiveCaseAsstistant(this.caseRecordId).subscribe(
            (data: any) => {
                    this.assistantName = data.result[0].caseTypeAssistantName;
                    this.statusFilterByGuid = data.result[0].status;
                    // const matchedObject = this.getObjectByGuid(data.result, this.caseTypeAssistantId);
                    // this.statusFilterByGuid = matchedObject
                    this.caseAssistantId = data.result[0].id
                      this.GetDocumentChatByCaseId();
                      this.startSignalRConnection()
            });
    }
        startSignalRConnection() {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${this.apiUrl}signalr-notificationhub`) 
            .build();
             this.hubConnection.start().then(() => {
                if(this.authService.tenantId && this.caseAssistantId){
                this.currentGroup = `tenant:${this.authService.tenantId}:assistant:${this.caseAssistantId}`;
                 console.log(this.currentGroup , ' CreateGroup');
                this.hubConnection.invoke('JoinCaseAssistantMessageGroup', `${this.authService.tenantId}`, this.caseAssistantId)
                .then(() => {
                        this.hubConnection.off('CreateCaseAssistantMessage');
                        this.hubConnection.on('CreateCaseAssistantMessage', (data: any) => {
                              let messageObj = data;
                                 messageObj = JSON.parse(data.message.caseMessage);
                         if (data.message.messageType === 'CreateCaseAssistantMessage') {
                                this.AiAgentMessages.push({
                                    questionText: messageObj.MessageFrom || messageObj.CaseAssistantMessage?.MessageFrom || '-',
                                    answerText: messageObj.Message || messageObj.CaseAssistantMessage?.Message || '-',
                                    messageOn: (messageObj.MessageOn || messageObj.CaseAssistantMessage?.MessageOn)?.endsWith('Z')
                                        ? (messageObj.MessageOn || messageObj.CaseAssistantMessage?.MessageOn)
                                        : ((messageObj.MessageOn || messageObj.CaseAssistantMessage?.MessageOn) + 'Z')
                                });
                                this.hasRecordsChange.emit(true);
                            }
                        });
                    })
                }
            if (this.authService.tenantId && this.caseRecordId) {
                this.currentGroup = `tenant:${this.authService.tenantId}:case:${this.caseRecordId}`;
                this.hubConnection.invoke('JoinCaseGroup', `${this.authService.tenantId}`, this.caseRecordId)
                .then(() => {
            this.isJoined = true;
            this.hubConnection.off('CaseChange');
            this.hubConnection.on('CaseChange', (data: any) => {
            console.log(data ,' CaseChange');

            if(data.message.status){
               this.updateCaseEventMessages.emit(data);
            }
           switch (data.message.messageType) {
            case 'CreateCase':
            // Handle create case logic
            this.createCaseMessages = this.createCaseMessages || [];
            this.createCaseMessages.push(data);
            this.updateCaseEventMessages.emit(data);
            break;
            case 'UpdateCase':
            // Handle update case logic
            this.updateCaseMessages = this.updateCaseMessages || [];
            this.updateCaseMessages.push(data);
            this.updateCaseEventMessages.emit(data);
            break;
            case 'CaseStatusUpdated':
            // Handle status update logic
            this.statusUpdateMessages = this.statusUpdateMessages || [];
            this.statusUpdateMessages.push(data);
            this.updateCaseEventMessages.emit(data);
            break;
            case 'UpdateJData':
            // Handle JData update logic
            this.updateJDataMessages = this.updateJDataMessages || [];
            this.updateJDataMessages.push(data);
            this.updateCaseEventMessages.emit(data);
            break;
            case 'CreateJData':
            // Handle JData create logic
            this.createJDataMessages = this.createJDataMessages || [];
            this.createJDataMessages.push(data);
            this.updateCaseEventMessages.emit(data);
            break;
            case 'DeleteJData':
            // Handle JData create logic
            this.deleteJDataMessages = this.deleteJDataMessages || [];
            this.deleteJDataMessages.push(data);
            this.updateCaseEventMessages.emit(data);
            break;
            case 'CreateFile':
            // Handle file create logic
            this.createFileMessages = this.createFileMessages || [];
            this.createFileMessages.push(data);
            break;
            case 'UpdateFile':
            // Handle file update logic
            this.updateFileMessages = this.updateFileMessages || [];
            this.updateFileMessages.push(data);
            break;
            case 'UnLockCase':
                this.updateCaseEventMessages.emit(data);
                break;
            case 'LockCase':
                this.updateCaseEventMessages.emit(data);
                break;
            default:
            // Handle unknown message types or fallback
            this.otherMessages = this.otherMessages || [];
            this.otherMessages.push(data);
            break;
        }
            });
            
          })
          
          .catch(err => console.error('Join error:', err));
      }
    })
    .catch(err => console.error('SignalR Connection Error: ', err));
        this.hubConnection.onclose((error) => {
        console.log('SignalR connection closed. Attempting to reconnect...', error);
        setTimeout(() => {
            this.startSignalRConnection();
        }, 3000); // Retry after 3 seconds
    });
}

    getBGClass(): string {
        switch (this.agent) {
            case 'Veris': return 'bg-veris-primary-500';
            case 'Revio': return 'bg-primary-revio-500';
            case 'Alera': return 'bg-primary-500';
            case 'accordia': return 'text-primary-accordia-200 ';
            default: return 'bg-primary-500';
        }
    }

    getTextClass(): string {
        switch (this.agent) {
            case 'Veris': return 'text-veris-primary-500';
            case 'Revio': return 'text-primary-revio-500';
            case 'Alera': return 'text-primary-500';
             case 'accordia': return 'text-primary-accordia-200 ';
            default: return 'text-primary-500';
        }
    }
    // postMessage() {
    //       if (this.questionText == '') {
    //         this.disableChat = false;
    //     } else {
    //         this.disableChat = true;
    //     }
    // let seconds = 0;
    // this.sequence = this.sequence + 1;
    // this.timerMessage = 'Thinking';
    // const timerInterval = setInterval(() => {
    //     seconds++;
    //     if (seconds === 30) {
    //         this.timerMessage = 'Thinking. Looks like I need time…';
    //     }
    //     if (seconds === 60) {
    //         this.timerMessage = 'Thinking. Still working on it…';
    //     }
    //     if (seconds === 90) {
    //         this.timerMessage = 'Thinking. Waiting for an answer…';
    //     }
    //     if (seconds === 120) {
    //         this.timerMessage = 'Sorry unable to answer currently.';
    //     }
    // }, 1000);

    // let params = {
    //     tenantId: this.authService.tenantId,
    //     caseId: this.caseRecordId,
    //     caseTypeId: this.caseTypeId,
    //     message: this.questionText,
    //     sequenceNumber: this.sequence,
    //     caseTypeAssistantId: this.assistantId
    // };

    // const question = this.questionText; // Save question before clearing
    // this.questionText = ''; // Clear input field immediately

    // this.service.CaseChat(params).subscribe((data: any) => {
    //     if (data.result.reply != null) {
    //         let objRecieve: chatMessage = {
    //             answerText: data.result.reply,
    //             creationTime: moment.utc().local().format('lll'),
    //             questionText: question
    //         };
    //         this.AiAgentMessages.push(objRecieve);
    //         clearInterval(timerInterval);
    //          this.disableChat = false;
    //     } else {
    //         let objRecieve: chatMessage = {
    //             answerText: 'Sorry unable to answer currently.',
    //             creationTime: moment.utc().local().format('lll'),
    //             questionText: question
    //         };
    //         this.AiAgentMessages.push(objRecieve);
    //         clearInterval(timerInterval);
    //         this.disableChat = false;
    //     }
    //     setTimeout(() => {}, 100);
    // }, error => {
    //     let objRecieve: chatMessage = {
    //         answerText: 'Sorry unable to answer currently.',
    //         creationTime: moment.utc().local().format('lll'),
    //         questionText: question
    //     };
    //     this.AiAgentMessages.push(objRecieve);
    //     clearInterval(timerInterval);
    //     this.disableChat = false;
    // });
    // }

}
